// Letter fonts. We deliberately use *system* font stacks rather than
// loading web fonts from a CDN: a privacy messenger shouldn't make the
// user's browser phone home to fonts.gstatic.com on every letter. Each
// stack resolves to something reasonable on iOS, Android, Windows, and
// macOS. The "Handwritten" one leans on the platform's cursive face, so
// it looks a little different per device — which is fine, it's a letter.

export type LetterFont = {
  id: string;
  name: string;
  stack: string;
};

export const LETTER_FONTS: LetterFont[] = [
  {
    id: 'serif',
    name: 'Serif',
    stack: '"Fraunces", Georgia, "Times New Roman", serif',
  },
  {
    id: 'typewriter',
    name: 'Typewriter',
    stack: '"Courier New", "Courier", ui-monospace, Menlo, monospace',
  },
  {
    id: 'modern',
    name: 'Modern',
    stack: 'system-ui, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  },
  {
    id: 'classic',
    name: 'Classic',
    stack: '"Iowan Old Style", "Palatino Linotype", Palatino, "Book Antiqua", Georgia, serif',
  },
  {
    id: 'hand',
    name: 'Handwritten',
    stack: '"Segoe Script", "Snell Roundhand", "Bradley Hand", "Comic Sans MS", cursive',
  },
];

export const DEFAULT_LETTER_FONT = LETTER_FONTS[0];

export function getLetterFont(id: string | undefined): LetterFont {
  if (!id) return DEFAULT_LETTER_FONT;
  return LETTER_FONTS.find((f) => f.id === id) ?? DEFAULT_LETTER_FONT;
}

export function nextLetterFont(id: string): LetterFont {
  const i = LETTER_FONTS.findIndex((f) => f.id === id);
  return LETTER_FONTS[(i + 1) % LETTER_FONTS.length];
}
